/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
import React from "react";
import FontAwesome from "react-fontawesome";
import { OverlayTrigger, Popover, Button } from "react-bootstrap";
import { Map } from "immutable";
import {
  determineTestScoreRangesMet,
  getTestEvents,
} from "containers/Results/FunctionLib";
import {
  getCandidateVideoInterviewData,
  getCandidateLiveInterviewData,
} from "utils/helperFunctions";
import warningIcon from "resources/images/warning-yellow@2x.png";
import ShareTestResults from "../CandidateProfileActions/actions/ShareTestResults";
import DownloadTestResults from "../CandidateProfileActions/actions/DownloadTestResults";
import EmailCandidates from "../CandidateProfileActions/actions/EmailCandidates";
import ScheduleTest from "../CandidateProfileActions/actions/ScheduleTestComponents/ScheduleTest";
import UploadResume from "../CandidateProfileActions/actions/UploadResume";
import Ratings from "../CandidateProfileActions/actions/Ratings";
import DeleteScheduledEvent from "../CandidateProfileActions/actions/DeleteScheduledEvent";
import BackgroundCheck from "../CandidateProfileActions/actions/BackgroundCheck";
import MoveCandidateToJob from "../CandidateProfileActions/actions/MoveCandidateToJob";
import CopyCandidateToJob from "../CandidateProfileActions/actions/CopyCandidateToJob";
import FlipCandidatePrivacy from "../CandidateProfileActions/actions/FlipCandidatePrivacy";
import DeleteCandidate from "../CandidateProfileActions/actions/DeleteCandidate";
import PendingEventsRow from "../CandidateProfilePendingEvents/PendingEventsRow";

export function calculateIfAllScoreRangesMet(
  candidateInfo,
  jobData,
  fromResultsV2
) {
  const scoreRanges = jobData && jobData.getIn(["scoreRange", "data"]);

  if (!scoreRanges || scoreRanges.size < 1) {
    return false;
  }

  const testEvents = getTestEvents(candidateInfo, fromResultsV2);

  if (!testEvents || !testEvents.size) {
    return false;
  }

  let allScoreRangesMet = true;
  let candidateHasTests = false;

  testEvents.forEach((testEvent) => {
    const tests = testEvent.get("tests");

    // for each test the candidate took, check if it had score ranges and if it met the score ranges
    if (tests && !tests.get("videoInterviewId")) {
      candidateHasTests = true;
      tests.forEach((test) => {
        const { testHasScoreRanges, metTestScoreRanges } =
          determineTestScoreRangesMet(test, scoreRanges);

        if (testHasScoreRanges && !metTestScoreRanges) {
          allScoreRangesMet = false;
          return false;
        }
      });
    }
  });

  return allScoreRangesMet && candidateHasTests;
}

export function displayLabels(candidateInfo) {
  const Labels = [];
  if (candidateInfo.get("labels")) {
    candidateInfo
      .get("labels")
      .keySeq()
      .forEach((labelId) => {
        Labels.push(
          <span
            className="label"
            key={labelId}
            style={{
              fontSize: "12px",
              fontWeight: 400,
              marginLeft: "8px",
              backgroundColor: "#E6E6E6",
              color: "#000",
              padding: "4px 8px",
            }}
          >
            {candidateInfo.get("labels").get(labelId)}
          </span>
        );
      });
  }
  return Labels;
}

export function getRatingDisplay(candidateInfo, ratingSystem) {
  const candidateAvgRating = candidateInfo.get("averageRating");
  if (
    candidateAvgRating === undefined ||
    candidateAvgRating === null ||
    !ratingSystem
  ) {
    return "";
  }
  if (ratingSystem.get("ratingType") === "stars") {
    const starsArray = [];
    for (let i = 0; i < Math.floor(candidateAvgRating); i += 1) {
      starsArray.push(<FontAwesome name="star" key={i} />);
    }
    const remainder = candidateAvgRating - Math.floor(candidateAvgRating);
    if (remainder < 0.25) {
      return starsArray;
    }
    if (remainder < 0.75) {
      starsArray.push(<FontAwesome name="star-half-o" key="half" />);
    } else {
      starsArray.push(<FontAwesome name="star" key="full" />);
    }
    return starsArray;
  }
  if (ratingSystem.get("ratingType") === "ten") {
    let remainder = candidateAvgRating - Math.floor(candidateAvgRating);
    if (remainder < 0.25) {
      remainder = 0;
    } else if (remainder >= 0.25 && remainder < 0.75) {
      remainder = 0.5;
    } else {
      remainder = 1;
    }
    return [
      <FontAwesome name="star" key="full" />,
      Math.floor(candidateAvgRating) + remainder,
    ];
  }
  return (
    <div>
      <FontAwesome
        name="thumbs-up"
        size="lg"
        key="thumbs_up"
        style={{ color: "#C0DEDD", lineHeight: "0px" }}
      />
      <span style={{ color: "#333", marginRight: "5px", marginLeft: "2px" }}>
        {candidateAvgRating.get ? candidateAvgRating.get("up") || 0 : null}
      </span>
      <FontAwesome
        name="thumbs-down"
        size="lg"
        key="thumbs_down"
        style={{ color: "#C0DEDD", lineHeight: "0px" }}
      />
      <span style={{ color: "#333", marginLeft: "2px" }}>
        {candidateAvgRating.get ? candidateAvgRating.get("down") || 0 : null}
      </span>
    </div>
  );
}

export function getStageName(currentStageId, pipeline, candidateInfo) {
  let stageName = false;
  if (["incomplete", "scheduled", "disqualified"].includes(currentStageId)) {
    stageName = currentStageId;
  } else {
    stageName =
      pipeline && pipeline.get("stages")
        ? pipeline
            .get("stages")
            .valueSeq()
            .reduce(
              (name, stage) =>
                name ||
                (String(stage.get("pipelineStageMapId")) ===
                String(candidateInfo.get("pipelineStageMapId"))
                  ? stage.get("stageName")
                  : false),
              false
            )
        : false;
  }
  return stageName;
}

export function getModalContent(
  currentProfileAction,
  candidateInfo,
  candidateName,
  currentCandidateId,
  jobs,
  currentJobId,
  jobData,
  onDownloadResults,
  changeProfileAction,
  onDeleteCandidate,
  placedAt,
  onLoadTestMakerTests,
  testMakerTests,
  showWorkStyles,
  fromResultsV2,
  handleFinishCandidateProfileAction = null
) {
  const candidateStatus = candidateInfo.get("candidateStatus");
  const eppTestEventsMap = candidateInfo.get("testEvents").get("34");
  const candidateTestEvents = candidateInfo
    .get("testEvents")
    .first()
    .get("tests");
  const isEPPCompleted = eppTestEventsMap
    ? eppTestEventsMap
        .first()
        .get("tests")
        .find((test) => test.get("testId") === 34 && test.get("finished") === 1)
    : candidateTestEvents
      ? candidateTestEvents.find(
          (test) => test.get("testId") === 34 && test.get("finished") === 1
        )
      : false;

  const areProctoringRecordingsAvailable =
    candidateInfo &&
    candidateInfo.get("proctoringSettings") &&
    candidateInfo
      .get("proctoringSettings")
      .some((testEvent) => testEvent && testEvent.get("enabled") === true);

  if (currentProfileAction) {
    const testEvents = getTestEvents(candidateInfo, fromResultsV2);

    const isActiveProctoredCandidate =
      candidateInfo &&
      candidateInfo
        .get("proctoringSettings")
        .keySeq()
        .some(
          (testEventId) =>
            candidateInfo.getIn([
              "proctoringSettings",
              testEventId,
              "enabled",
            ]) &&
            !candidateInfo.getIn([
              "proctoringSettings",
              testEventId,
              "dateEventTaken",
            ]) &&
            candidateInfo.get("candidateStatus") !== 2
        );

    switch (currentProfileAction) {
      case "shareResults":
        return (
          <ShareTestResults
            changeAction={changeProfileAction}
            candidateIds={[currentCandidateId]}
            showWorkStyles={showWorkStyles}
            candidateStatus={candidateStatus}
            isEPPCompleted={isEPPCompleted}
          />
        );
      case "downloadResults":
        return (
          <DownloadTestResults
            changeAction={changeProfileAction}
            candidateIds={[currentCandidateId]}
            onDownloadResults={onDownloadResults}
            showWorkStyles={showWorkStyles}
            candidateStatus={candidateStatus}
            isEPPCompleted={isEPPCompleted}
            areProctoringRecordingsAvailable={areProctoringRecordingsAvailable}
          />
        );
      case "emailCandidate":
        return (
          <EmailCandidates
            changeAction={changeProfileAction}
            candidateIds={[currentCandidateId]}
          />
        );
      case "scheduleTest":
        return (
          <ScheduleTest
            changeAction={changeProfileAction}
            candidateIds={[currentCandidateId]}
            jobId={currentJobId}
            jobData={jobData}
            candidateName={candidateName}
            candidate={candidateInfo}
            onLoadTestMakerTests={onLoadTestMakerTests}
            testMakerTests={testMakerTests}
            candidateStageId={candidateInfo.get("pipelineStageMapId")}
          />
        );
      case "uploadResume":
        return (
          <UploadResume
            changeAction={changeProfileAction}
            currentCandidateId={currentCandidateId}
            candidateStageId={candidateInfo.get("pipelineStageMapId")}
          />
        );
      case "backgroundCheck":
        return (
          <BackgroundCheck
            changeAction={changeProfileAction}
            currentCandidateId={currentCandidateId}
            candidateName={candidateName}
          />
        );
      case "ratings":
        return (
          <Ratings
            changeAction={changeProfileAction}
            candidateId={currentCandidateId}
            userRatedCandidate={candidateInfo.get("userRatedCandidate")}
            candidateAvgRating={candidateInfo.get("averageRating")}
            candidateName={candidateName}
            jobId={currentJobId}
            candidateStageId={candidateInfo.get("pipelineStageMapId")}
          />
        );
      case "emailEventInfo":
        return (
          <EmailCandidates
            changeAction={changeProfileAction}
            candidateIds={[currentCandidateId]}
            callLocation="testEventInfo"
            testEventId={testEvents && testEvents.keySeq().get(0)}
            candidateName={candidateName}
          />
        );

      case "deleteScheduledEvent":
        return (
          <DeleteScheduledEvent
            changeAction={changeProfileAction}
            testEvents={testEvents}
            candidateId={currentCandidateId}
          />
        );
      case "flipCandidatePrivacy":
        return (
          <FlipCandidatePrivacy
            candidateId={currentCandidateId}
            candidatePrivate={candidateInfo.get("isPrivate") === 1}
            changeAction={changeProfileAction}
          />
        );
      case "moveCandidateToJob":
        return (
          <MoveCandidateToJob
            jobs={jobs}
            jobId={currentJobId}
            candidateIds={[currentCandidateId]}
            changeAction={changeProfileAction}
            handleFinishCandidateProfileAction={
              handleFinishCandidateProfileAction
            }
            hasActiveProctoredCandidates={isActiveProctoredCandidate}
          />
        );
      case "copyCandidateToJob":
        return (
          <CopyCandidateToJob
            jobs={jobs}
            jobId={currentJobId}
            candidateIds={[currentCandidateId]}
            changeAction={changeProfileAction}
          />
        );
      case "deleteCandidate":
        return (
          <DeleteCandidate
            currentCandidateId={currentCandidateId}
            changeAction={changeProfileAction}
            candidateStageId={candidateInfo.get("pipelineStageMapId")}
            onDeleteCandidate={onDeleteCandidate}
            jobId={currentJobId}
            placedAt={placedAt}
            handleFinishCandidateProfileAction={
              handleFinishCandidateProfileAction
            }
          />
        );
      default:
        return "";
    }
  }
  return null;
}

export function displayPendingEventsRow(
  allUsers,
  candidateInfo,
  currentCandidateId,
  fromResultsV2,
  moveEmailCandidatesPermission,
  onPendingEventsActionCompletion,
  onShowExtendExpirationModal,
  showDeleteConfirmationModal,
  showVideoInterviewAdjustmentsModal,
  showReleaseScoresModal,
  showReminderErrorModal,
  showReminderModal,
  pendingEvents,
  updateExtendExpirationCandidateIds,
  updateExtendExpirationTestEventIds,
  user,
  jobData
) {
  const invitedEvents = [];
  const inProgressEvents = [];

  const testEvents = getTestEvents(candidateInfo, fromResultsV2);

  if (
    pendingEvents !== null &&
    Object.keys(pendingEvents).includes("invited")
  ) {
    const candidateWillNotBeReminded =
      !testEvents ||
      testEvents.filter(
        (testEvent) =>
          testEvent.get("trueDateEventStarted") === null &&
          testEvent.get("eventExpired") === 0
      ).size === 0;

    Object.keys(pendingEvents.invited).forEach((testEvent) => {
      const event = pendingEvents.invited[testEvent];
      invitedEvents.push(
        <PendingEventsRow
          allUsers={allUsers}
          candidate={candidateInfo}
          candidateWillNotBeReminded={candidateWillNotBeReminded}
          currentCandidateId={currentCandidateId}
          deleteInvitedCandidate={showDeleteConfirmationModal}
          event={event}
          fromInvited
          fromResultsV2={fromResultsV2}
          jobData={jobData}
          key={testEvent}
          moveEmailCandidatesPermission={moveEmailCandidatesPermission}
          onPendingEventsActionCompletion={onPendingEventsActionCompletion}
          onShowExtendExpirationModal={onShowExtendExpirationModal}
          permissionScoreReports={user.permissionScoreReports}
          showReleaseScoresModal={showReleaseScoresModal}
          showReminderErrorModal={showReminderErrorModal}
          showReminderModal={showReminderModal}
          showVideoInterviewAdjustmentsModal={
            showVideoInterviewAdjustmentsModal
          }
          testEvent={testEvent}
          updateExtendExpirationCandidateIds={
            updateExtendExpirationCandidateIds
          }
          updateExtendExpirationTestEventIds={
            updateExtendExpirationTestEventIds
          }
        />
      );
    });
  }
  if (
    pendingEvents !== null &&
    Object.keys(pendingEvents).includes("inProgress")
  ) {
    const candidateWillNotBeReminded =
      !testEvents ||
      testEvents.filter(
        (testEvent) =>
          testEvent.get("trueDateEventStarted") !== null &&
          testEvent.get("eventExpired") === 0
      ).size === 0;

    Object.keys(pendingEvents.inProgress).forEach((testEvent) => {
      const event = pendingEvents.inProgress[testEvent];
      inProgressEvents.push(
        <PendingEventsRow
          allUsers={allUsers}
          candidate={candidateInfo}
          candidateWillNotBeReminded={candidateWillNotBeReminded}
          currentCandidateId={currentCandidateId}
          deleteInvitedCandidate={showDeleteConfirmationModal}
          event={event}
          fromInvited={false}
          fromResultsV2={fromResultsV2}
          jobData={jobData}
          key={testEvent}
          moveEmailCandidatesPermission={moveEmailCandidatesPermission}
          onPendingEventsActionCompletion={onPendingEventsActionCompletion}
          onShowExtendExpirationModal={onShowExtendExpirationModal}
          permissionScoreReports={user.permissionScoreReports}
          showReleaseScoresModal={showReleaseScoresModal}
          showReminderErrorModal={showReminderErrorModal}
          showReminderModal={showReminderModal}
          showVideoInterviewAdjustmentsModal={
            showVideoInterviewAdjustmentsModal
          }
          testEvent={testEvent}
          updateExtendExpirationCandidateIds={
            updateExtendExpirationCandidateIds
          }
          updateExtendExpirationTestEventIds={
            updateExtendExpirationTestEventIds
          }
        />
      );
    });
  }
  return [invitedEvents, inProgressEvents];
}

export const getWarningIcon = ({
  warningType = "videoInterview",
  currentJobHasActiveVideoInterview,
  videoInterviewDataToShow,
}) => {
  let popoverText;
  const iconProps = {
    src: warningIcon,
    alt: "warning",
    width: "16px",
    height: "16px",
    style: { marginBottom: "0.25rem" },
  };

  if (warningType === "videoInterview") {
    if (videoInterviewDataToShow && !currentJobHasActiveVideoInterview) {
      popoverText =
        "This job was updated. The Video Interview action has been removed from this job.";
    } else {
      popoverText =
        "This job was updated. The video interview template has changed and this candidate's results are from an older version.";
    }
  } else if (warningType === "testBattery") {
    popoverText =
      "This job was updated. This candidate's test results are from an older version of the test battery associated with this job.";
  } else if (warningType === "combined") {
    popoverText =
      "This job was updated. The video interview template and test battery associated with this job has changed and this candidate's results are from an older version.";
  }

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Popover
          id={`${warningType}Warning`}
          style={{
            padding: "5px 10px",
          }}
        >
          {popoverText}
        </Popover>
      }
    >
      <span className="ml-1">
        <img
          src={iconProps.src}
          width={iconProps.width}
          height={iconProps.height}
          style={iconProps.style}
          alt={iconProps.alt}
        />
      </span>
    </OverlayTrigger>
  );
};

export const getCandidateHasOldTests = (
  candidateInfo,
  jobData,
  fromResultsV2
) => {
  const candidateTestIds = [];
  const jobTestIds = [];
  const candidateOldTestIds = [];

  const testEvents = getTestEvents(candidateInfo, fromResultsV2);

  if (testEvents) {
    testEvents.forEach((testEvent) => {
      const tests = testEvent.get("tests");

      if (tests) {
        tests.forEach((test) => {
          candidateTestIds.push(String(test.get("testId")));
        });
      }
    });
  }

  jobData
    .get("batteries")
    .get("data")
    .keySeq()
    .forEach((testBatteryId) => {
      const testBattery = jobData
        .get("batteries")
        .get("data")
        .get(String(testBatteryId));

      testBattery.keySeq().forEach((testId) => {
        const newTestId = testId.includes("TM")
          ? testId.replace("TM", "")
          : testId;

        jobTestIds.push(newTestId);
      });
    });

  candidateTestIds.map((testId) => {
    if (!jobTestIds.includes(testId)) {
      candidateOldTestIds.push(testId);
    }
  });

  return candidateOldTestIds;
};

export const convertEventKeyToSectionHeader = {
  1: "Results",
  2: "Pending Events",
  3: "Resume",
  4: "Application",
  5: "Attachments",
  6: "Notes & History",
};

export const convertNavKeyToSectionSubHeader = {
  1: "Summary",
  videoInterviewEvaluators: "Evaluators",
  videoInterviewScoreSummary: "Score",
  liveInterviewEvaluators: "Evaluators",
  liveInterviewScoreSummary: "Score",
};

export const segmentTrackResultsSectionViews = (
  currentJobId,
  sectionHeader,
  sectionSubHeader,
  currentCandidateId,
  companyAccountId = null,
  testEventId = null
) => {
  const formData = {
    "job detail id": currentJobId,
    "section header": sectionHeader,
    "section subheader": sectionSubHeader,
    "test taker id": currentCandidateId,
  };
  
  // Add companyAccountId and testEventId only for CTRSE reports
  if (sectionSubHeader === "CTRSE") {
    if (companyAccountId) formData["company account id"] = companyAccountId;
    if (testEventId) formData["test event id"] = testEventId;
  }
  
  const eventName = sectionSubHeader === "CTRSE" ? "CTRS Express Report viewed" : "results section viewed";
  window.analytics.track(eventName, formData);
};

/**
 * Tracks CTRSE report downloads in Segment
 * @param {string} currentJobId - The current job ID
 * @param {string} sectionHeader - The section header
 * @param {string} currentCandidateId - The candidate ID
 * @param {string} companyAccountId - The company account ID
 * @param {string} testEventId - The test event ID
 */
export const trackCTRSEReportDownloaded = (
  currentJobId,
  sectionHeader,
  currentCandidateId,
  companyAccountId,
  testEventId
) => {
  const formData = {
    "job detail id": currentJobId,
    "section header": sectionHeader,
    "section subheader": "CTRSE",
    "test taker id": currentCandidateId,
  };
  
  // Add company account ID and test event ID if available
  if (companyAccountId) formData["company account id"] = companyAccountId;
  if (testEventId) formData["test event id"] = testEventId;
  
  // Track the download event
  window.analytics.track("CTRS Express Report downloaded", formData);
};

const determineCandidateHasTests = (candidateInfo, fromResultsV2) => {
  const testEvents = getTestEvents(candidateInfo, fromResultsV2);

  let hasTests = false;

  testEvents.forEach((testEvent) => {
    if (testEvent.get("tests")) {
      hasTests = true;
      return false;
    }
  });

  return hasTests;
};

/* begin of get pending events helper functions group */

const getPendingEventInfo = (event, eventId) => {
  const eventStatus = event.get("trueDateEventStarted")
    ? "inProgress"
    : "invited";

  const eventIdAsKey = event.get("testEventId");

  // we need to do this to keep the Results v2 VI-only event data structure consistent for the PendingEventsRow component
  let videoInterviewMap = new Map();
  if (eventId === "videoInterview") {
    videoInterviewMap = videoInterviewMap.setIn(
      ["videoInterviews", eventIdAsKey],
      event
    );
  }

  // we need to do this to keep the Results v2 LI data structure consistent for the PendingEventsRow component
  let liveInterviewMap = new Map();
  if (eventId === "liveInterviews") {
    liveInterviewMap = liveInterviewMap.setIn(
      ["liveInterviews", eventIdAsKey],
      event
    );
  }

  const eventInfo = {
    eventId: event.get("eventId"),
    scheduledBy: event.get("scheduledBy"),
    date:
      eventStatus === "inProgress"
        ? event.get("trueDateEventStarted")
        : event.get("dateEventAdded") || event.get("dateCreated"),
    tests: event.get("tests"),
    videoInterviews:
      eventId === "videoInterview"
        ? videoInterviewMap.get("videoInterviews")
        : event.get("videoInterviews"),
    liveInterviews:
      eventId === "liveInterviews"
        ? liveInterviewMap.get("liveInterviews")
        : event.get("liveInterviews"),
  };

  return { eventStatus, eventIdAsKey, eventInfo };
};

const isNotPendingEvent = (event, eventId, testEvents, deletedTestEventIds) => {
  // 1. tests/application-only event, event completed: event has a valid dateEventTaken value and no videoInterviews
  if (event.get("dateEventTaken") && !event.get("videoInterviews")) {
    return true;
  }

  // 2. LI event - Results v1 structure: LI event's 'dateCompleted' is the time that all evaluators have evaluated
  // return early if LI event is completed or deleted
  if (
    event.get("liveInterviews") &&
    (event.get("dateCompleted") ||
      deletedTestEventIds.includes(String(event.get("testEventId"))))
  ) {
    return true;
  }

  // 3. VI + A event: Results v2 structure will return 2 testEvents, one keyed with 'videoInterview' with VI only data and one keyed with {testEventId} that includes both AX data and VI data, so we need to avoid duplication
  if (
    eventId === "videoInterview" &&
    testEvents.has(String(event.get("testEventId")))
  ) {
    return true;
  }

  // 4. VI + A event, event completed: event has a valid dateEventTaken value, has videoInterviews, and all videoInterviews have a valid dateCompleted value
  const hasCompletedVI =
    event.get("videoInterviews") &&
    event
      .get("videoInterviews")
      .filter(
        (videoInterview) =>
          Boolean(videoInterview.get("dateCompleted")) === true
      ).size ===
      (event.get("videoInterviews") && event.get("videoInterviews").size);

  return event.get("dateEventTaken") && hasCompletedVI;
};

const handleLIPendingEventsInResultsV2 = (
  event,
  eventId,
  deletedTestEventIds,
  pendingEvents
) => {
  const pendingEventsCopy = pendingEvents;
  event.forEach((liveInterview) => {
    // return early if LI event is completed or deleted
    if (
      liveInterview.get("dateCompleted") ||
      deletedTestEventIds.includes(String(liveInterview.get("testEventId")))
    ) {
      return;
    }

    const { eventStatus, eventIdAsKey, eventInfo } = getPendingEventInfo(
      liveInterview,
      eventId
    );

    if (pendingEventsCopy[eventStatus]) {
      pendingEventsCopy[eventStatus][eventIdAsKey] = eventInfo;
    } else {
      pendingEventsCopy[eventStatus] = {
        [eventIdAsKey]: eventInfo,
      };
    }
  });
  return pendingEventsCopy;
};

// Get Pending Events
export const getPendingEvents = (
  candidate,
  fromResultsV2,
  deletedTestEventIds = []
) => {
  let pendingEvents = {};

  const testEvents = getTestEvents(candidate, fromResultsV2);

  if (!testEvents) {
    return pendingEvents;
  }

  testEvents.forEach((event, eventId) => {
    if (isNotPendingEvent(event, eventId, testEvents, deletedTestEventIds)) {
      return null;
    }

    // LI Results v2 structure is different (nested multiple) so need to handle separately
    if (eventId === "liveInterviews") {
      pendingEvents = handleLIPendingEventsInResultsV2(
        event,
        eventId,
        deletedTestEventIds,
        pendingEvents
      );

      return;
    }

    const { eventStatus, eventIdAsKey, eventInfo } = getPendingEventInfo(
      event,
      eventId
    );

    if (pendingEvents[eventStatus]) {
      pendingEvents[eventStatus][eventIdAsKey] = eventInfo;
    } else {
      pendingEvents[eventStatus] = {
        [eventIdAsKey]: eventInfo,
      };
    }
  });

  return pendingEvents;
};

/* end of getPendingEvents helper functions group */

/* begin of getInitialProfileTabs helper functions group */

const shouldReturnDefaultProfileTabs = (
  userData,
  candidateInfo,
  currentCandidateId,
  candidateLiveInterviewDataToShow
) => {
  const isInsightUser = userData && userData.partnerAccountId === 47;

  if (
    !candidateInfo ||
    isInsightUser || // Maintain default tab opening logic for Insight users
    (candidateInfo.get("candidateId") &&
      candidateInfo.get("candidateId") !== currentCandidateId) // if candidateInfo & currentCandidateId are out of sync from Search results
  ) {
    return true;
  }

  // If there is a live interview event, regardless of the event status
  // always default open 'Results' tab and return early
  return candidateLiveInterviewDataToShow;
};

const getDefaultTabs = (
  state,
  noCandidateSummary,
  candidateLiveInterviewDataToShow
) => {
  let summaryTab = "1"; // Summary
  let liveInterviewDefaultState = "";

  if (noCandidateSummary && candidateLiveInterviewDataToShow) {
    summaryTab = "2"; // Default to first live interview which has event key number '2' (the next event key after the Summary tab key '1')
    liveInterviewDefaultState = "liveInterviewEvaluators";
  } else if (state) {
    summaryTab = state.summaryLeftTab;
    liveInterviewDefaultState = state.liveInterviewSelectedView;
  }

  // Default tabs
  return {
    topProfileActiveTab: state ? state.topProfileActiveTab : "1", // Results
    summaryLeftTab: summaryTab,
    videoInterviewSelectedView: state ? state.videoInterviewSelectedView : "", // no default state as users need to manually select an option
    liveInterviewSelectedView: liveInterviewDefaultState, // no default state as users need to manually select an option. but if LI is the only event and it's pending, then default to evaluators view
    interviewSubTabEventKey: liveInterviewDefaultState ? "2" : "",
  };
};

// For opening the correct profile tabs on mount
export const getInitialProfileTabs = (
  {
    candidateInfo,
    candidateSummaries,
    currentCandidateId,
    userData,
    fromResultsV2,
  },
  state,
  deletedTestEventIds
) => {
  // Empty candidate summary indicates pending results
  const noCandidateSummary =
    candidateSummaries && candidateSummaries.get(currentCandidateId) === "";

  const candidateLiveInterviewDataToShow =
    Object.keys(
      getCandidateLiveInterviewData(candidateInfo, deletedTestEventIds)
    ).length > 0;

  const profileTabs = getDefaultTabs(
    state,
    noCandidateSummary,
    candidateLiveInterviewDataToShow
  );

  // check for cases that we can simply return the default tabs
  if (
    shouldReturnDefaultProfileTabs(
      userData,
      candidateInfo,
      currentCandidateId,
      candidateLiveInterviewDataToShow
    )
  ) {
    return profileTabs;
  }

  const { candidateVideoInterviewDataToShow } =
    getCandidateVideoInterviewData(candidateInfo);

  const candidateHasTests = determineCandidateHasTests(
    candidateInfo,
    fromResultsV2
  );

  // Pending events can be test, VI, applications or resume events
  const candidateHasPendingEvents =
    Object.keys(
      getPendingEvents(candidateInfo, fromResultsV2, deletedTestEventIds)
    ).length > 0;

  const candidateHasCompletedVI =
    candidateVideoInterviewDataToShow &&
    candidateVideoInterviewDataToShow.get("dateCompleted");

  // If candidate has tests has pending events, and has VI event, default to Results first
  // Then check if no summaries available and if the VI is pending
  // If both conditions are met, default to open Pending Events tab first
  // The rest cases should default to open Results tab first
  if (
    candidateHasTests ||
    candidateVideoInterviewDataToShow ||
    candidateHasPendingEvents
  ) {
    if (noCandidateSummary) {
      if (!candidateHasCompletedVI) {
        profileTabs.topProfileActiveTab = "2"; // Pending Events
      }
    }

    return profileTabs;
  }

  // Otherwise if Results tab will not show, set the top profile tab to open first instead
  switch (true) {
    case candidateInfo.get("resumeAvailable") === 1:
      profileTabs.topProfileActiveTab = "3"; // Resume
      break;
    case candidateInfo.get("applicationAvailable") === 1:
      profileTabs.topProfileActiveTab = "4"; // Application
      break;
    default:
      profileTabs.topProfileActiveTab = "5"; // Attachments (default since always present)
      break;
  }

  return profileTabs;
};

// this helper function is mainly used for opening the first live interview tab on mount, if LI is the only event and it's pending
export const getFirstLiveInterviewId = (candidateInfo, deletedTestEventIds) => {
  const candidateLiveInterviewData = getCandidateLiveInterviewData(
    candidateInfo,
    deletedTestEventIds
  );

  let firstLiveInterviewId = null;
  if (Object.keys(candidateLiveInterviewData).length > 0) {
    firstLiveInterviewId = Object.keys(candidateLiveInterviewData)[0];
  }

  return firstLiveInterviewId;
};

/* end of getInitialProfileTabs helper functions group */

export const getVIActionButton = (
  isVISampleJob,
  currentJobHasActiveVideoInterview,
  currentVideoInterviewResultData,
  candidateVideoInterviewDataToShow,
  alcamiIframeUrl,
  isCurrentUserEvaluator,
  handleReviewResponses,
  handleEvaluateInterview
) => {
  // Show the review responses button when:
  // Candidate has VI result but job no longer has VI associated - this is different UI handled separately in the `InterviewTabContentHeader` component, so we return early here
  // VI Sample Job - there are pending evaluations in the results data
  // Regular VI Jobs - the current user is an evaluator and has evaluated, or if the user is not an evaluator at all
  if (!(isVISampleJob || currentJobHasActiveVideoInterview)) {
    return;
  }

  if (
    (isVISampleJob &&
      currentVideoInterviewResultData &&
      currentVideoInterviewResultData.get("evaluationsPending") === 0) ||
    (!isVISampleJob &&
      currentJobHasActiveVideoInterview &&
      (candidateVideoInterviewDataToShow.get("currentUserEvaluated") ||
        !isCurrentUserEvaluator))
  ) {
    return (
      <Button
        className="ml-2"
        variant="outline-primary"
        onClick={() => handleReviewResponses(alcamiIframeUrl)}
        disabled={!currentJobHasActiveVideoInterview}
      >
        <FontAwesome name="check" /> Review Responses
      </Button>
    );
  }

  // If all else fails show the Evaluate Interview Button
  return (
    <Button
      className="ml-2"
      variant="primary"
      size="sm"
      onClick={() => handleEvaluateInterview()}
      id="evaluateVideoInterview"
      disabled={!currentJobHasActiveVideoInterview}
    >
      <FontAwesome name="file-o" /> Evaluate Interview
    </Button>
  );
};

export const getSMSTimelineText = (action) => {
  let actionText = "";

  if (action === "sms-CandidateInvitation") {
    actionText = "Invitation";
  } else if (action === "sms-CandidateInvitationReminder") {
    actionText = "Reminder";
  }

  return `${actionText} SMS sent: Default ${actionText} Template`;
};
